import { AxiosResponse } from 'axios';
import { SET_INVOICE_ITEMS, SET_INVOICE_ITEM, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_INVOICE_ITEM_ISLOADING,
  DELETE_INVOICE_ITEM,
  EDIT_INVOICE_ITEM,
  GET_INVOICE_ITEMS,
  GET_INVOICE_ITEM,
  REGISTER_INVOICE_ITEM,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import InvoiceItem from '@/services/invoice_item';
import { Module } from 'vuex';
import { EditInvoiceItem, RegisterInvoiceItem, GetInvoiceItem } from '@/dtos/invoice_item.dto';

const invoiceItem: Module<any, {}> = {
  state: {
    invoiceItem: {
      data: null,
      isLoading: false,
    },
    invoiceItems: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    invoiceItem: (state: { invoiceItem: any }) => state.invoiceItem,
    invoiceItems: (state: { invoiceItems: any }) => state.invoiceItems,
  },
  mutations: {
    [SET_INVOICE_ITEM]: (
      state: { invoiceItem: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.invoiceItem.data = payload.data) : null,
        (state.invoiceItem.isLoading = payload.isLoading);
    },
    [SET_INVOICE_ITEMS]: (
      state: { invoiceItems: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.invoiceItems.data = payload.data) : null,
        (state.invoiceItems.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_INVOICE_ITEM]: async ({ commit }: any, payload: any) => {
      commit(SET_INVOICE_ITEM, { data: null, isLoading: true });

      const result: AxiosResponse = await InvoiceItem.registerInvoiceItem(
        payload as RegisterInvoiceItem
      );

      if (result) {
        if (result.data.status) {
          commit(SET_INVOICE_ITEM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INVOICE_ITEM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INVOICE_ITEM, { isLoading: false });
        return false;
      }
    },
    [GET_INVOICE_ITEMS]: async ({ commit }: any, payload: any) => {
      commit(SET_INVOICE_ITEMS, { data: null, isLoading: true });

      const result: AxiosResponse = await InvoiceItem.getInvoiceItems(
        payload as GetInvoiceItem
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_INVOICE_ITEMS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INVOICE_ITEMS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INVOICE_ITEMS, { isLoading: false });
        return false;
      }
    },
    [GET_INVOICE_ITEM]: async ({ commit }: any, payload: any) => {
      commit(SET_INVOICE_ITEM, { data: null, isLoading: true });

      const result: AxiosResponse = await InvoiceItem.getInvoiceItems(
        payload as GetInvoiceItem
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_INVOICE_ITEM, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_INVOICE_ITEM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INVOICE_ITEM, { isLoading: false });
        return false;
      }
    },
    [EDIT_INVOICE_ITEM]: async ({ commit }: any, payload: any) => {
      commit(SET_INVOICE_ITEM, { data: null, isLoading: true });

      const result: AxiosResponse = await InvoiceItem.editInvoiceItem(
        payload as EditInvoiceItem
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_INVOICE_ITEM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INVOICE_ITEM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INVOICE_ITEM, { isLoading: false });
        return false;
      }
    },
    [DELETE_INVOICE_ITEM]: async ({ commit }: any, payload: string) => {
      commit(SET_INVOICE_ITEM, { data: null, isLoading: true });

      const result: AxiosResponse = await InvoiceItem.deleteInvoiceItem(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_INVOICE_ITEM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_INVOICE_ITEM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_INVOICE_ITEM, { isLoading: false });
        return false;
      }
    },
    [CLEAR_INVOICE_ITEM_ISLOADING]: ({ commit }) => {
      commit(SET_INVOICE_ITEM, { isLoading: false });
      commit(SET_INVOICE_ITEMS, { isLoading: false });
    },
  },
};

export default invoiceItem;

